import { render, staticRenderFns } from "./DropshippingSales.vue?vue&type=template&id=62a3f15e&"
import script from "./DropshippingSales.vue?vue&type=script&lang=js&"
export * from "./DropshippingSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports